export default function TopNavigation({step}: {step: number})
{
    const steps = ['Личные данные', 'Позиции на возврат', 'Реквизиты для возврата'];

    return (<ul className="lk__order-status">
        {steps.map((item, index) => <li key={index}><i className={index < step ? 'active' : ''}></i><p>{item}</p></li>)}
    </ul>)
}